import * as types from './actions';
import APIUtil from '../config/APIUtil';
import UrlConstants from '../config/UrlConstants';
import * as code from '../config/Constants';

/**
 * 
 * @desc Darshboard transactions data api call
 */
export function transactionsAction() {

    return function (dispatch){
        return APIUtil.getMethod(UrlConstants.DashboardTransactionsUrl, true).then(response => {
            if(response.status === code.OK) {
                dispatch( {
                    type: types.DASHBOARD_TRANSACTIONS,
                    dashboardTranscations : response.data.transactions,
                    countTransactions : response.data.totalTransactions, 
                });
            }
            else {
                dispatch( {
                    type: types.DASHBOARD_TRANSACTIONS,
                    dashboardTranscations : [],
                    countTransactions: []
                });
            }
            return response;          
        });
    } 
}
/**
 * @desc Dashboard Upcoming Tasks - get All
 */
export function getDashboardTasksWidgetAction() {

    let url = UrlConstants.DashboardwidgetFourUrl;

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.GET_UPCOMING_TASKS_DASHBOARD,
                  upcomingTasksData: response.data
              });
          }
          else {
              dispatch( {
                  type: types.GET_UPCOMING_TASKS_DASHBOARD,
                  upcomingTasksData: []
              });
          }
          return response.data || {}
      });
    }  
}

/**
 * @desc Dashboard - get Transactions values
 */
export function getTransactionValuesWidgetDataAction() {

    let url = UrlConstants.TransactionValuesWidgetDataUrl;

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.DASHBOARD_TRANSACTIONS_VALUE,
                  valuesData: response.data
              });
          }
          else {
              dispatch( {
                  type: types.DASHBOARD_TRANSACTIONS_VALUE,
                  valuesData: []
              });
          }
          return response.data || {};
      });
    }  
}



/**
 * @desc Dashboard - get Transactions Commission
 */
export function getCommissionWidgetDataAction() {

    let url = UrlConstants.CommissionWidgetDataUrl;

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.DASHBOARD_COMMISSION,
                  commissionData : response.data
              });
          }
          else {
              dispatch( {
                  type: types.DASHBOARD_COMMISSION,
                  commissionData: []
              });
          }
          return response.data || {};
      });
    }  
}

/**
 * @desc Dashboard - get Task as per counter click
 */
export function getTaskList(taskType,recordPerPage,pageIndex) {

    let url = UrlConstants.DashboardTaskListingUrl + "/" + taskType + "?limit=" +recordPerPage + "&offset=" +pageIndex;

    return function (dispatch){
      return APIUtil.getMethod(url, true).then(response => {
          if(response.status == code.OK) {
              dispatch( {
                  type: types.DASHBOARD_TASK_LIST,
                  taskList: response.data,
                  totalTasks:response.data.total
              });
          }
          else {
              dispatch( {
                  type: types.DASHBOARD_TASK_LIST,
                  taskList: []
              });
          }
          return response.data || {};
      });
    }  
}
